import { axiosInstance } from ".."

const updateProjectFolderpath = async (prjCode,data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`internal/projects/${prjCode}`,data).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default updateProjectFolderpath;